import { Component, inject } from '@angular/core';

import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-echarge-banner',
  templateUrl: './echarge-banner.component.html',
  styleUrls: ['./echarge-banner.component.scss'],
  standalone: false,
})
export class EChargeBannerComponent {
  private readonly bottomSheetRef = inject<MatBottomSheetRef<unknown>>(MatBottomSheetRef);

  public handleDownloadButtonClicked() {
    this.bottomSheetRef.dismiss();
  }

  public close() {
    this.bottomSheetRef.dismiss();
  }
}
